var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items)?_c('fieldset',{staticClass:"item-selector",class:{
		grid: _vm.grid
	}},[(_vm.legend)?_c('legend',{staticClass:"item-selector-legend",domProps:{"textContent":_vm._s(_vm.legend)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"items"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"individual-item",class:item.class},[_c('input-item-with-label',{attrs:{"item":item,"on-item-click":_vm.onItemClick,"buffer-text":""}})],1)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }